import { Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';

function PublicApp() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="*" element={<div>Page Not Found</div>} />
    </Routes>
  );
}

export default PublicApp;
